import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          
          {/* Logo Section */}
          <div className="lg:col-span-1 flex justify-center sm:justify-start">
            {/* <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-pink-600 to-purple-700 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg sm:text-xl">AWM</span>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg sm:text-xl font-medium mb-4 sm:mb-6 font-display">Quick Link</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#men" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Men
                </a>
              </li>
              <li>
                <a href="#women" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Women
                </a>
              </li>
              <li>
                <a href="#collection" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Collection
                </a>
              </li>
              <li>
                <a href="#virtual" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Virtual
                </a>
              </li>
            </ul>
          </div>

          {/* AWM */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg sm:text-xl font-medium mb-4 sm:mb-6 font-display">AWM</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#about" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Contact us
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#blog" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Blog
                </a>
              </li>
              <li>
                <a href="#press" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Press
                </a>
              </li>
              <li>
                <a href="#careers" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg sm:text-xl font-medium mb-4 sm:mb-6 font-display">Policies</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#terms" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#shipping" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Shipping
                </a>
              </li>
              <li>
                <a href="#return" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Return
                </a>
              </li>
              <li>
                <a href="#payment" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Payment Policy
                </a>
              </li>
            </ul>
          </div>

          {/* My Account */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg sm:text-xl font-medium mb-4 sm:mb-6 font-display">My Account</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#login" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Login
                </a>
              </li>
              <li>
                <a href="#shopping-bag" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Shopping Bag
                </a>
              </li>
              <li>
                <a href="#wishlist" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Wishlist
                </a>
              </li>
              <li>
                <a href="#order-tracking" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Order Tracking
                </a>
              </li>
              <li>
                <a href="#order-history" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm sm:text-base font-body">
                  Order History
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-[#622935] mt-8 sm:mt-12 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="text-gray-300 font-body text-sm sm:text-base text-center sm:text-left">
              © 2025 All Rights Reserved.
            </div>
            <div className="text-gray-300 font-body text-sm sm:text-base text-center sm:text-right">
              lorem ipsum
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;